import {
  getAuth,
  OAuthProvider,
  signInWithPopup,
  UserCredential,
} from "firebase/auth";

// The scope for read/write access to a user's primary calendar.
const CALENDAR_SCOPE = "https://www.googleapis.com/auth/calendar";

export const signInWithGoogle = async (): Promise<UserCredential> => {
  const auth = getAuth();
  const provider = new OAuthProvider("google.com");

  // This is the crucial part: asking for the calendar scope.
  provider.addScope(CALENDAR_SCOPE);

  try {
    const result = await signInWithPopup(auth, provider);
    // The result contains the user's information and, most importantly, the OAuth access token.
    return result;
  } catch (error) {
    console.error("Error during Google sign-in:", error);
    throw error;
  }
};

// You can get the access token from the result like this:
// const credential = OAuthProvider.credentialFromResult(result);
// const accessToken = credential?.accessToken;
